import React from 'react';
import injectSheet from 'react-jss';

// Components
import Page from '../components/Page';
import SignInForm from '../components/SignInForm';
import Head from 'next/head';

interface Props {
  classes: any;
}

function SignIn({ classes }: Props) {
  return (
    <>
      <Head>
        <title>Sign In - TestNotify</title>
        <meta name="description" content="Sign into TestNotify." />
      </Head>
      <Page classes={{ children: classes.root, content: classes.content }} centered>
        <SignInForm />
      </Page>
    </>
  );
}

const styles = theme => {
  return {
    root: {
      maxWidth: theme.widths.card,
    },
    content: {
      textAlign: 'center',
    },
  };
};

export default injectSheet(styles)(SignIn);
